/* RESPONSIBLE TEAM: team-standalone */
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { attr, type SyncHasMany } from '@ember-data/model';
import { type AllChannels } from 'embercom/lib/operator/custom-bots/constants';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type { Block } from 'embercom/models/common/blocks/block';
import { fragmentArray } from 'ember-data-model-fragments/attributes';

export enum SalesforceCaseDescriptionSource {
  TEXT = 'text',
  AI_SUMMARY = 'ai_summary',
  TRANSCRIPT = 'transcript',
}

export type HandoffToSalesforceOwnerIdByIntegration = {
  integration_id: string;
  handoff_id: string | null;
}[];

export default class HandoffToSalesforceCase extends Step {
  @service declare finStandaloneService: FinStandaloneService;

  @attr('string') declare caseRecordTypeId: string | null;
  @attr('string') declare handoffToSalesforceOwnerId: string | null;
  @attr('array', { defaultValue: () => [] })
  declare handoffToSalesforceOwnerIdByIntegration: HandoffToSalesforceOwnerIdByIntegration;
  @attr('string') declare salesforceCaseDescriptionSource?: SalesforceCaseDescriptionSource;

  @fragmentArray('common/blocks/block', { polymorphic: true, typeKey: 'modelKey' })
  declare salesforceCaseDescriptionBlocks?: SyncHasMany<Block>;

  @fragmentArray('common/blocks/block', { polymorphic: true, typeKey: 'modelKey' })
  declare salesforceCaseSubjectBlocks?: SyncHasMany<Block>;

  get supportedChannels(): Readonly<AllChannels[]> {
    return SUPPORTED_CHANNELS.handoffToSalesforceCase;
  }

  static get supportedContexts(): TargetContext[] {
    return [TargetContext.Conversation];
  }

  static get isStepGroupEnding(): boolean {
    return true;
  }

  static get isStepTerminal(): boolean {
    return true;
  }

  static createNewStep(store: Store): HandoffToSalesforceCase {
    return store.createRecord('operator/visual-builder/step/handoff-to-salesforce-case', {
      type: 'operator/visual-builder/step/handoff-to-salesforce-case',
    });
  }
}
